import { set } from 'lodash'
import _forEach from 'lodash/forEach'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import CollectionDisplay from './CollectionDisplay'
import Resources from './Resources'

const Collection = ({ collection }) => {
  const userCollection = useSelector(
    (state) => state.userCollection.collectionByCard,
  )
  const galaktikaCollection = useSelector(
    (state) => state.galaktikaCollection.collections.Others,
  )

  const [tab, setTab] = useState('spark')
  const cards = userCollection?.Civilizations?.[collection] // Added static data to simulate the request
  const otherCards = userCollection?.Others

  const COLLECTION = collection.toUpperCase()
  const stickers = []
  const sparks = []
  const krystals = []
  const synergy = []
  const portals = []

  _forEach(otherCards, function (card, type) {
    if (type.includes('Sticker') && type.includes(COLLECTION)) {
      stickers.push({ name: type, card })
    }
    if (type.includes('SPARK')) {
      sparks.push({ name: type, card })
    }
    if (type.includes('Synergy')) {
      synergy.push({ name: type, card })
    }
    if (type.includes('Portal')) {
      portals.push({ name: type, card })
    }
    if (type.includes('Krystal')) {
      krystals.push({ name: type, card })
    }
  })
  useEffect(() => {
    console.log('STICKERS:', otherCards)
    console.log('KRYSTALS:', sparks)
    console.log('PORTAL:', krystals)
    console.log('SYNERGY:', synergy)
    console.log('SPARK:', portals)

    
  })

  

  return (
    <section
      id="scrollbar"
      className={`w-full p-10 ${
        collection === 'Galaktika' ? 'pt-5' : ''
      }  overflow-auto`}
    >
      {collection === 'Galaktika' ? (
        <Resources tab={tab} setTab={setTab} krystals={krystals} portals={portals} synergy={synergy} sparks={sparks} />
      ) : (
        <CollectionDisplay civilization={collection} cards={cards} stickers={stickers} />
      )}
    </section>
  )
}

export default Collection
